import * as fromRouter from '@ngrx/router-store';

import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
// import * as fromNav from '../reducers/nav.reducer';

export const getRouterState = createSelector(
  fromFeature.getRouterState,
  (state: fromRouter.RouterReducerState<fromFeature.RouterStateUrl>) => state);

export const getBreadCrumbs = createSelector(
  getRouterState,
  (state: fromRouter.RouterReducerState<fromFeature.RouterStateUrl>) => state?.state?.breadCrumbs);
